type SuggestedFiltersConsolidationBucketConfig = {
  layout: 'split' | 'standard';
  placement: 'around' | 'limit';
};

export const SUGGESTED_FILTERS_CONSOLIDATION_EXPERIMENT =
  'car-merch-ui-srp-suggested-filters-consolidation';

export const SUGGESTED_FILTERS_CONSOLIDATION_BUCKET_CONFIGS = new Map<
  string,
  SuggestedFiltersConsolidationBucketConfig
>([
  ['around-split', { layout: 'split', placement: 'around' }],
  ['around-standard', { layout: 'standard', placement: 'around' }],
  ['limit-split', { layout: 'split', placement: 'limit' }],
  ['limit-standard', { layout: 'standard', placement: 'limit' }]
]);

export const SUGGESTED_FILTERS_CONSOLIDATION_TREATMENT_BUCKETS: Array<string> =
  [...SUGGESTED_FILTERS_CONSOLIDATION_BUCKET_CONFIGS.keys()];
